export default {
  es: {
    operation: 'Operación',
    create: 'Crear parámetro',
    view: 'Ver parámetro',
    edit: 'Editar parámetro',
    deleteParameter: '¿Estás seguro de eliminar este parámetro?',
    key: 'Llave',
    value: 'Valor',
    parameterCreated: 'Un nuevo parámetro ha sido creado',
    parameterUpdated: 'Un parámetro ha sido actualizado',
    parameterDeleted: 'Un parámetro ha sido eliminado'
  },
  en: {
    operation: 'Operation',
    create: 'Create parameter',
    view: 'View parameter',
    edit: 'Edit parameter',
    deleteParameter: 'Do you want to delete this parameter?',
    key: 'Key',
    value: 'Value',
    parameterCreated: 'A new parameter have been created',
    parameterUpdated: 'A parameter have been updated',
    parameterDeleted: 'A parameter have been deleted'
  }
};
